/* src/app/components/lead-details/summary/lead-detail-summary/lead-detail-summary.component.css */
.chart-container {
  width: 500px;
  height: 500px;
}
.chart-box {
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.ppl-form-item {
  width: 100% !important;
}
.filter-title {
  font-size: 1.714rem;
  font-weight: 600;
  color: #01796F;
  margin-bottom: 1rem;
  text-align: bottom;
}
.view-welcome-letter,
.download-welcome-letter {
  width: 100px;
  color: white !important;
}
.button-container {
  display: flex;
  justify-content: space-evenly;
}
.summary-heading {
  background-color: #bebdf575;
  padding: 4px;
  border-radius: 4px;
  font-size: 1.286rem;
  margin-bottom: 10px;
  margin-top: 0;
  font-weight: 500;
}
.completed-count {
  font-size: 1.5rem !important;
}
.highlight {
  color: #1890ff;
  cursor: pointer;
}
li.nostyle {
  list-style-type: none;
}
/*# sourceMappingURL=lead-detail-summary.component-36IFQ4ZV.css.map */
